import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import {
  Organization,
  OrganizationAdmin,
  OrganizationDetails,
  OrganizationDetailsByDataBricks,
} from '@atlassian/cssxp-types-organization';
import { CloudSubscription } from '@atlassian/cssxp-typescommon';

const client = createAxiosClient({ baseURL: '/api/1/organizations' }, ServiceProxyMap.ANS);

export interface OrganizationAdminResponse {
  totalHits: number;
  results: OrganizationAdmin[];
}

export async function fetchOrganization(domain: string) {
  const response = await client.get<Organization>(`/${encodeURIComponent(domain)}`);

  return response.data;
}

export async function fetchOrganizationDetailsByDatabricks(domain: string) {
  const response = await client.get<OrganizationDetailsByDataBricks>(`/${encodeURIComponent(domain)}/databricks`);

  return response.data;
}

export async function fetchOrganizationById(orgId: string) {
  const response = await client.get<OrganizationDetails>(`/orgId/${encodeURIComponent(orgId)}`);

  return response.data;
}
export async function fetchOrganizationAdmins(orgId: string): Promise<OrganizationAdminResponse> {
  const response = await client.get(`/${orgId}/admins`);

  return response.data;
}

export async function fetchRelatedProducts(orgId: string, size: number, offset: number) {
  const response = await client.get<{
    totalHits: number;
    results: CloudSubscription[];
  }>(`/${encodeURIComponent(orgId)}/products`, {
    params: {
      size,
      offset,
    },
  });

  return response.data;
}
